import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AddNonWorkingDay, EditAddNonWorkingDay } from './non-working-day.interface';

@Injectable({
    providedIn: 'root',
})
export class NonWorkingDayService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.zileLibere.list;

    public listDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.zileLibere.listDT;

    private findURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.zileLibere.find;

    private storeURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.zileLibere.store;

    private updateUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.zileLibere.update;

    private deleteUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.zileLibere.delete;

    // private listActiveUrl =
    //     this.basePath +
    //     environment.interop.indoc.nomenclatoare.registratura.zileLibere
    //         .listActive;

    // private listPublicUrl =
    //     this.basePath +
    //     environment.interop.indoc.nomenclatoare.registratura.zileLibere
    //         .listPublic;

    // private changeStatusActiveUrl =
    //     this.basePath +
    //     environment.interop.indoc.nomenclatoare.registratura.zileLibere
    //         .active;

    // private changeStatusPublicUrl =
    //     this.basePath +
    //     environment.interop.indoc.nomenclatoare.registratura.zileLibere
    //         .public;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: AddNonWorkingDay) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: EditAddNonWorkingDay) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
